export const statusColor = {
    "Pending Approval": {
        "bg": "#FDEEB1",
        "text": "#C48A00"
    },
    "Approved": {
        "bg": "#B2EABA",
        "text": "#61B165"
    },
    "Rejected": {
        "bg": "#FFC7CD",
        "text": "#F75E6E"
    },
    "Cancelled": {
        "bg": "#DBE3EB",
        "text": "#2F4551"
    },
    "Pending Cancellation": {
        "bg": "#FDEEB1",
        "text": "#C48A00"
    },
}

export const timeOffNames = {
    "OO": {
        "CAN": {
            "TOUNP": "Time Off (Unpaid)",
        },
        "USA": {
            "TOUNP": "Time Off (Unpaid)",
        }
    },
    "CO": {
        "CAN": {
            "TOVAC": "Vacation",
            "TOPER": "Personal Leave (Paid)",
            "TOSIC": "Sick Leave (Paid)",
            "TOBER": "Bereavement (Paid)",
            "TOUNP": "Time Off (Unpaid)",
        },
        "USA": {
            "TOVAC": "Personal Time Off (Paid)",
            "TOUNP": "Time Off (Unpaid)",
            "TOBER": "Bereavement (Paid)",
            "VACPAYOUT":"Vacation Payout",
        }
    }
}